export const LollipopStyles = {
  display: "flex",
  justifyContent: "center",
  marginTop: "10px",
  "& .highcharts-data-table": {
    marginLeft: "60px",
  },
};
